export default class NotMerchantError extends Error {}
